import React from "react"
import { Anchor as MantineAnchor, createPolymorphicComponent } from "@mantine/core"
import type { AnchorProps } from "@mantine/core"

import { Icon } from "@/components"

export const _Anchor = ({ children, ...props }: AnchorProps & HTMLAnchorElement & { component: any }) => {
    const isExternalLink = props.target === "_blank" || props.href?.startsWith("http")

    return (
        <MantineAnchor {...props}>
            {children}
            {isExternalLink ? <Icon icon="external-link" /> : ""}
        </MantineAnchor>
    )
}

export const Anchor = createPolymorphicComponent<"a", AnchorProps>(_Anchor)
